import { MerchantUser } from 'APIs/merchant.users/merchant.users.types';
import { ReactElement, useCallback } from 'react';

import UserDataTable from './UserDataTable';
import UserModal from './UserModal';
import { AddNewUser, TableHeader } from './styles';
import { UserFormProps, toUserFormProps } from './types';

type Props = {
  actionUsers: Array<string>;
  users: Array<MerchantUser>;
  fetchingError: string;
  merchantUser: MerchantUser | null;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  isModalLoading: boolean;
  isLoading: boolean;
  modalErrorMsg: string;
  setModalErrorMsg: (modalErrorMsg: string) => void;
  setMerchantUser: (merchantUser: MerchantUser | null) => void;
  resendEmail: (userId: string) => void;
  saveMerchantUserHandler: (formData: UserFormProps) => void;
};

const UserList = ({
  actionUsers,
  users,
  fetchingError,
  merchantUser,
  showModal,
  setShowModal,
  isModalLoading,
  isLoading,
  modalErrorMsg,
  setModalErrorMsg,
  setMerchantUser,
  resendEmail,
  saveMerchantUserHandler,
}: Props): ReactElement => {
  const getUser = useCallback(
    (userId: string): MerchantUser | null => {
      if (users.length === 0) return null;
      const userToEdit = users.filter((user) => user._id === userId);

      if (userToEdit.length === 0) return null;
      return userToEdit[0];
    },
    [users],
  );

  const handleAddNew = () => {
    setModalErrorMsg('');
    setMerchantUser(null);
    setShowModal(true);
  };

  const editUser = useCallback(
    (userId: string) => {
      const mUser = getUser(userId);
      if (mUser) {
        setMerchantUser(mUser);
        setModalErrorMsg('');
        setShowModal(true);
      }
    },
    [getUser, setMerchantUser, setModalErrorMsg, setShowModal],
  );

  return (
    <div>
      <TableHeader>
        <h3 className="mb-0">Users</h3>
        <AddNewUser onClick={handleAddNew}>Add new</AddNewUser>
      </TableHeader>

      <UserDataTable
        userList={users}
        fetchListLoader={isLoading}
        isErrorRequest={!!fetchingError}
        handleEditUser={editUser}
        handleResendEmail={resendEmail}
        actionUsers={actionUsers}
      />

      {showModal && (
        <UserModal
          userFormProps={merchantUser ? toUserFormProps(merchantUser) : null}
          saveMerchantHendler={saveMerchantUserHandler}
          modalErrorMsg={modalErrorMsg}
          isModalLoading={isModalLoading}
          setShowModal={setShowModal}
        />
      )}
    </div>
  );
};

export default UserList;
